import { render, staticRenderFns } from "./lq003a.vue?vue&type=template&id=97cc0640"
import script from "./lq003a.vue?vue&type=script&lang=js"
export * from "./lq003a.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports